import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = (props) => {
  const { user } = useAuth();
  const { children } = props;

  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return children
};

export default ProtectedRoute;
